const countdownElement = document.getElementById("countdown");
const targetDate = new Date(
  countdownElement.getAttribute("data-target-date")
).getTime();

function padWithZero(number) {
  return number < 10 ? "0" + number : number;
}

function updateCountdown() {
  const currentTime = new Date().getTime();
  const difference = targetDate - currentTime;

  const days = Math.floor(difference / (1000 * 60 * 60 * 24));
  const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((difference / 1000 / 60) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  if (difference > 0) {
    document.getElementById("countdown__days").textContent = padWithZero(days);
    document.getElementById("countdown__hours").textContent =
      padWithZero(hours);
    document.getElementById("countdown__minutes").textContent =
      padWithZero(minutes);
    document.getElementById("countdown__seconds").textContent =
      padWithZero(seconds);
  } else {
    clearInterval(interval);
    document.getElementById("countdown__days").textContent = "00";
    document.getElementById("countdown__hours").textContent = "00";
    document.getElementById("countdown__minutes").textContent = "00";
    document.getElementById("countdown__seconds").textContent = "00";
  }
}

updateCountdown();
const interval = setInterval(updateCountdown, 1000);
